"use strict";
/** state: Final **/
/** family: Checkbox **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var trackMetric_1 = require("../../metrics/trackMetric");
var Checkbox_1 = require("../Checkbox");
var Fieldset_1 = require("../Fieldset");
var CLASS_NAME = 'i-checkbox-group';
/**
 * Container for rendering 'Checkbox' components.
 *
 * Components are displayed the order in which they are declared.
 */
var CheckboxGroup = function (_a) {
    var className = _a.className, disabled = _a.disabled, legend = _a.legend, metricOptions = _a.metricOptions, mode = _a.mode, name = _a.name, onChange = _a.onChange, options = _a.options, inline = _a.inline, restProps = __rest(_a, ["className", "disabled", "legend", "metricOptions", "mode", "name", "onChange", "options", "inline"]);
    var handleChange = function (e, _) {
        var target = e.target;
        var targetIndex = target.parentNode.getAttribute('data-index');
        var updatedOption = __assign({}, options[targetIndex], { checked: target.checked });
        onChange && onChange(e, updatedOption);
    };
    return (React.createElement(Fieldset_1.Fieldset, __assign({ role: "group", className: classNames(CLASS_NAME, className), disabled: disabled, legend: legend }, restProps), options.map(function (option, i) { return (React.createElement(Checkbox_1.Checkbox, { disabled: disabled, key: i, mode: mode, name: name, label: option.label, value: option.value, checked: Boolean(option.checked), onChange: trackMetric_1.trackMetric(metricOptions, handleChange), "data-index": i, isInline: inline })); })));
};
exports.CheckboxGroup = CheckboxGroup;
//# sourceMappingURL=CheckboxGroup.js.map